(function () {
    'use strict';

    angular.module('app.currency', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();